import * as React from "react"
import { Box, Typography } from "@mui/material"

import { NotAllowedBlock } from "@components"


export default function percentageColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value) => value === null || value === undefined
				? <Box sx={{ textAlign: 'center' }}><NotAllowedBlock sx={{ fontWeight: 'bold' }}/></Box>
				: <Typography variant="body2" sx={{ textAlign: 'center' }}>
					{value + '%'}
				</Typography>
		}
	}
}